import { navigate } from '@reach/router'
import React from 'react'

import ProfileAvatar from '@cinch/oxd-components/profile-link/src/components/profile-avatar'

import * as styles from './partners-auth-info.module.css'

export interface PartnersAuthInfoProps {
  type?: string
  dealerIsAuthenticated?: boolean
  dealerName?: string
}

const PartnersAuthInfo: React.FC<PartnersAuthInfoProps> = ({
  type = 'desktop',
  dealerIsAuthenticated = false,
  dealerName = '',
}) => {
  // todo refactor this out of components
  if (!dealerIsAuthenticated) {
    setTimeout(() => navigate('/partners'))

    return null
  }

  return (
    <div className={type === 'desktop' ? styles.profileLine : styles.profileLineMobile}>
      <div className={styles.profileText}>{dealerName}</div>
      <ProfileAvatar isAuthenticated={true} />
    </div>
  )
}

export default PartnersAuthInfo
